<app-view-title [isSplitColor]="true"></app-view-title>

<view-content [centered]="true">
  <app-information-screen title="{{ 'Intellitrailer.Rental.ReturnInfo.Title' | translate : 'Return' }}"
                          primaryContent="{{ 'Intellitrailer.Rental.ReturnInfo.Message' | translate : 'Park the trailer at the designated area at the location.' }}"
                          secondaryContent="{{ 'Intellitrailer.Rental.ReturnInfo.Message2' | translate : 'Make sure that you have room to go over the trailer and take photos during the return process.' }}">
  </app-information-screen>
</view-content>

<view-actions mode="white">
  <button mat-raised-button (click)="next()">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
</view-actions>

